import { default as domainUser } from './user/store' 
import { default as domainAccessLogin } from './login/store'

export default { 
	domainUser,
	domainAccessLogin
}
